import Vue from 'vue';
import axios from 'axios';

const state = {
	items: [],
};

axios.interceptors.request.use(
	function(config) {
		return config;
	}
);
axios.interceptors.response.use(
	function(response) {
		return response;
	},
	function(error) {
		console.log(error);
	}
);

const getters = {
	items: (state) => { return state.items; },
};

const actions = {
	fetchItems({commit}, options) {
		return new Promise((resolve) => {
			axios
				.get(options.apiUrl + '/api/Search/Autocomplete?q=' + options.q,
					{
						crossDomain: true
					})
				.then(response => {
					if(response && response.data) {
						let data = response.data.data;
						commit('setItems', data);
						resolve();
					}
				});
		});
	},
};

const mutations = {
	setItems(state, items) {
		Vue.set(state, 'items', items);
	}
};

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations,
};
